'use strict';
import angular from 'angular';

angular.module('currentUser.services').factory('Vendor', ['Role', function(Role) {
    return Role.newFrozenInstance();
}]);